<template>
  <div></div>
</template>

<script>
import { Jodit } from 'jodit';
import 'jodit/build/jodit.min.css';
export default {
  name: 'JoditVue',
  props: {
    value: { type: String, required: true },
    buttons: { type: Array, default: null },
    extraButtons: { type: Array, default: null },
    config: { type: Object, default: () => ({}) },
    useFileUpload: { type: Boolean, default: true }
  },
  data: () => ({ editor: null }),
  computed: {
    editorConfig() {
      const config = { ...this.config };
      if (this.buttons) {
        config.buttons = this.buttons;
        config.buttonsMD = this.buttons;
        config.buttonsSM = this.buttons;
        config.buttonsXS = this.buttons;
      }
      if (this.extraButtons) config.extraButtons = this.extraButtons;

      config.events = !this.useFileUpload
        ? {
            beforePaste: (event) => {
              if (!event || !event.clipboardData) return;

              const cd = event.clipboardData;
              const hasFiles = cd.files && cd.files.length > 0;

              const items = cd.items || [];
              const hasImageItem = Array.prototype.some.call(items, (item) => {
                return item.kind === 'file' && item.type && item.type.indexOf('image/') === 0;
              });

              const html = cd.getData('text/html') || '';
              const hasImgTag = /<img[\s\S]*?>/i.test(html);

              if (hasFiles || hasImageItem || hasImgTag) {
                event.preventDefault();
                event.stopPropagation();
                return false;
              }
            }
          }
        : null;

      return config;
    }
  },
  watch: {
    value(newValue) {
      if (this.editor.value !== newValue) this.editor.value = newValue;
    }
  },
  mounted() {
    try {
      this.editor = new Jodit(this.$el, this.editorConfig);
      this.editor.value = this.value;
      this.editor.events.on('change', (newValue) => this.$emit('input', newValue));
    } catch (e) {
      console.log(e);
    }
  },
  beforeDestroy() {
    this.editor.destruct();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/JoditVue.vue